import * as types from "../actionTypes"

/**
 * Sends event IDs to the clipboard and sets the
 * clipboard to copy mode.
 * @param {Array} eventUuids An array of IDs for the affected events.
 * @param {Number} calendarId The source calendar ID to look up events from.
 * @return {Object} An FSA action.
 */
export const copyEvents = (eventUuids, calendarId) => ({
  type: types.COPY_EVENTS,
  payload: { eventUuids, calendarId },
})
